/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconQuotes = createReactComponent("quotes", "IconQuotes", [
  ["path", { d: "M4 12c-1.333 -1.854 -1.333 -4.146 0 -6", key: "svg-0" }],
  ["path", { d: "M8 12c-1.333 -1.854 -1.333 -4.146 0 -6", key: "svg-1" }],
  ["path", { d: "M16 18c1.333 -1.854 1.333 -4.146 0 -6", key: "svg-2" }],
  ["path", { d: "M20 18c1.333 -1.854 1.333 -4.146 0 -6", key: "svg-3" }]
]);

export { IconQuotes as default };
//# sourceMappingURL=IconQuotes.js.map
